import Level1 from '@crehana/compass.icons.fill/Level1';
import Level2 from '@crehana/compass.icons.fill/Level2';
import Level3 from '@crehana/compass.icons.fill/Level3';
export var DEFAULT_HOVER_DELAY_MILLIS = 620;
var LevelProps = {
  size: 16,
  className: 'tw-mr-0.4 tw-fill-current tw-text-neutral-light-600'
};
export var COURSE_LEVEL_ICON_MAP_COMP = {
  introductorio: Level1,
  intermedio: Level2,
  avanzado: Level3,
  completo: Level3
};
export var COURSE_LEVEL_ICON_MAP = {
  introductorio: /*#__PURE__*/COURSE_LEVEL_ICON_MAP_COMP.introductorio(LevelProps),
  intermedio: /*#__PURE__*/COURSE_LEVEL_ICON_MAP_COMP.intermedio(LevelProps),
  avanzado: /*#__PURE__*/COURSE_LEVEL_ICON_MAP_COMP.avanzado(LevelProps),
  completo: /*#__PURE__*/COURSE_LEVEL_ICON_MAP_COMP.completo(LevelProps)
};
export var DEFAULT_IMG_CONTENT = 'https://crehana-public-catalog.imgix.net/images/app/gallery/2023/12/20/d08e784f/b3b57c7c.jpg';